import moment from 'moment'
import PropTypes from 'prop-types'
import { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import React from 'react'

import _ from 'lodash'
import { buyOrContentTypeFeedsOptions, buyOrContentTypeFeedsParam, DATA_FORMAT_OPTIONS_BY_VALUE, SPOT_EXPOSURE_MUST_COLUMN, supportsBrandFiltering, requiresFilterExpressionClearOnSubmit } from '../../../constants'
import { selectAllClients } from '../../../selectors'
import { getCriteriaByFeedType } from '../../../utils'
import CountrySelection, { countryOptions } from '../CountrySelection'
import ClientAndType, { NO_PANEL_JOIN_COUNTRIES } from './ClientAndType'
import ClientCredentials from './ClientCredentials'
import DatesAndCriteria from './DatesAndCriteria'
import FeedSpecifications from './FeedSpecifications'
import Footer from './Footer'
import Header from './Header'
import IncludedContent from './IncludedContent'
import SuccessMessage from './SuccessMessage'
import reportConfigs from '../../../reducers/reportConfigs'

const setAllCriteriasValues = (type, value, country, pbse_version) => {
  const CRITERIAS = getCriteriaByFeedType(type, country, pbse_version);

  // keep the constans for must columns
  return CRITERIAS.reduce((acc, criteria) => {
    acc[criteria] =
      (type === "spot exposure" && SPOT_EXPOSURE_MUST_COLUMN[criteria]) ||
      value;

    return acc;
  }, {});
};

const modalStyles = {
  overlay: {
    display: "flex",
    backgroundColor: "rgba(33,37,48,0.9)",
    zIndex: "1000",
  },
  content: {
    position: "static",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    width: "670px",
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    overflow: "visible",
  },
};

export const INITIAL_STEP = "setCountry";

export const INITIAL_TYPE = 'spot exposure'

export const INITIAL_FEED = {
  client_id: null,
  quality_metrics: {
    minimum_impression_count: null,
  },
  name: "BMWEXP003",
  included_brands: [],
  included_advertisers: [],
  included_parents: [],
  included_products: [],
  pdp_infomediary: null,
  service_start: null,
  service_stop: null,
  pdp_use_crosswalk: false,
  do_panel_join: true,
  /** @type {import('../../../constants').FEED_TYPE} */
  type: INITIAL_TYPE,
  tivo_report: false,
  pbse_version: null,
  data_format: DATA_FORMAT_OPTIONS_BY_VALUE.get('parquet'),
  country: countryOptions[0],
  cadence: "weekly",
  misc_json: {},
  cadenceError: null,
  x_ref_cadence: "daily",
  x_ref_cadence_day: null,
  selectedBuyOrContentType: buyOrContentTypeFeedsOptions[INITIAL_TYPE][1],
  deliveryAirflow: true,
};

export class CreateFeedModal extends Component {
  state = {
    step: INITIAL_STEP,
    feed: { ...INITIAL_FEED },
    loading: false,
    includeAllBrands: false,
    selectedCriterias: {},
    successMessage: null,
  };

  onChangeBrandsSelection = this.onChangeBrandsSelection.bind(this);
  onChangeFeed = this.onChangeFeed.bind(this);
  onChangeStep = this.onChangeStep.bind(this);
  onChangeSuccessMessage = this.onChangeSuccessMessage.bind(this);
  onDismiss = this.onDismiss.bind(this);
  onSubmit = this.onSubmit.bind(this);
  onCriteriaChange = this.onCriteriaChange.bind(this);
  onCheckAllChange = this.onCheckAllChange.bind(this);
  setInitialSelectedValues = this.setInitialSelectedValues.bind(this);

  updateCriteria = this.updateCriteria.bind(this);

  updateCriteria(key, type) {
    let { selectedCriterias } = this.state;
    if (type === "add") {
      this.setState({
        selectedCriterias: { ...selectedCriterias, [key]: false },
      });
    } else {
      delete selectedCriterias[key];
      this.setState({ selectedCriterias: { ...selectedCriterias } });
    }
  }

  setInitialSelectedValues() {
    const selectedCriterias = setAllCriteriasValues(
      this.state.feed.type,
      false,
      this.state.feed.country,
      this.state.feed.pbse_version,
    );
    this.setState({ selectedCriterias });
  }

  onCheckAllChange(event, value = undefined, toIgnore = []) {
    const isChecked = value !== undefined ? value : !this.state.checkAll;
    const selectedCriterias = setAllCriteriasValues(
      this.state.feed.type,
      isChecked,
      this.state.feed.country,
      this.state.feed.pbse_version,
    )

    if (toIgnore.length > 0)
      Object.keys(selectedCriterias).forEach((key, index) => {
        if (toIgnore.includes(key)) {
          selectedCriterias[key] = false
        }
      })

    this.setState({
      checkAll: isChecked,
      selectedCriterias,
    });
  }

  setSelectedCountry = this.setSelectedCountry.bind(this);

  setSelectedCountry(country) {
    const feed = { ...this.state.feed };
    feed.country = country;

    if (
      country.value !== "GB" &&
      country.value !== "AU" &&
      feed.pbse_version &&
      feed.pbse_version.value === "1.4.3"
    ) {
      feed.pbse_version = null;
    }

    this.setState({ feed });
  }

  onCriteriaChange(criteria) {
    const currentValue = this.state.selectedCriterias[criteria];
    const newCriterias = {
      ...this.state.selectedCriterias,
      [criteria]: !currentValue,
    };

    this.setState({ selectedCriterias: newCriterias });
  }

  onChangeBrandsSelection(includeAllBrands) {
    this.setState({ includeAllBrands });
  }

  onChangeFeed(field, value) {
    this.setState(prevState => {
      const feed = _.clone(prevState.feed);
      if (field === "client_id") {
        const selectedClient = this.props.clients.find(
          (client) => client.id === value
        );
        // TODO: Once we offer more than TV Ad Exposure files (EXP),
        // and a feed has a `type` we should update this accordingly
        feed.name = `${selectedClient.abbreviation}EXP`;
        feed[field] = value;
      } else if (field === "minimum_impression_count") {
        const qualityMetrics = { ...feed.quality_metrics };
        qualityMetrics[field] = value;
        feed.quality_metrics = qualityMetrics;
      } else if (field === "service_start" || field === "service_stop") {
        if (value) {
          // Store dates as UTC midnight to avoid timezone issues that can cause off-by-one day errors
          feed[field] = moment(value).utc().startOf('day');
        }

        if (field === "service_start") {
          if (moment(feed[field]).weekday() !== 0 && feed.cadence === "28 days") {
            feed.cadenceError = true;
          } else {
            feed.cadenceError = false;
          }
        }
      } else if (field === "cadence") {
        feed[field] = value;
        if (moment(feed.service_start).weekday() !== 0 && value === "28 days") {
          feed.cadenceError = true;
        } else {
          feed.cadenceError = false;
        }
      } else {
        feed[field] = value;
      }

      return { ...prevState, feed: { ...prevState.feed, ...feed } }
    });
  }

  onChangeStep(step) {
    this.setState({ step });
  }

  onChangeSuccessMessage(successMessage) {
    this.setState({ successMessage });
  }

  onDismiss() {
    // We shouldn't close the modal if it's loading
    if (this.state.loading) return;

    this.props.onDismiss();
    this.setState({
      step: INITIAL_STEP,
      feed: { ...INITIAL_FEED },
      loading: false,
      includeAllBrands: false,
    });
  }

  onSubmit() {
    if (this.state.loading) return;
    this.setState({ loading: true });

    const selectedClient = this.props.clients.find(
      (client) => client.id === this.state.feed.client_id
    );

    const {
      included_brands,
      included_parents,
      included_advertisers,
      included_products,
      country,
      ...feed
    } = this.state.feed;

    const canSetDeliveryMethod =
      selectedClient.misc_json &&
      selectedClient.misc_json.self_serve_delivery &&
      feed.deliveryAirflow;

    // If includeAllBrands, we should set `brand` to null
    if (this.state.includeAllBrands) {
      feed.kantar_filter_expression = {
        brand_blacklist: ["Unknown Brand"],
      };
    } else {
      // Otherwise, convert the array of brands to an array of names
      let brand = included_brands
        .map((brand) => brand.label)
        .sort((a, b) => a.localeCompare(b));
      let parent_name = included_parents
        .map((parent) => parent.label)
        .sort((a, b) => a.localeCompare(b));
      let advertiser_name = included_advertisers
        .map((advertiser) => advertiser.label)
        .sort((a, b) => a.localeCompare(b));
      let product_name = included_products
        .map((product) => product.label)
        .sort((a, b) => a.localeCompare(b));
      if (brand.length) {
        feed.kantar_filter_expression = {
          ...feed.kantar_filter_expression,
          brand,
        };
      }
      if (parent_name.length) {
        feed.kantar_filter_expression = {
          ...feed.kantar_filter_expression,
          parent_name,
        };
      }
      if (advertiser_name.length) {
        feed.kantar_filter_expression = {
          ...feed.kantar_filter_expression,
          advertiser_name,
        };
      }
      if (product_name.length) {
        feed.kantar_filter_expression = {
          ...feed.kantar_filter_expression,
          product_name,
        };
      }
    }

    if (requiresFilterExpressionClearOnSubmit(feed.type)) {
      feed.do_panel_join = true;
      feed.kantar_filter_expression = null;
      feed.quality_metrics = {};
    }

    const cols_to_include = Object.keys(this.state.selectedCriterias).filter(
      // eslint-disable-next-line
      (key) => {
        if (this.state.selectedCriterias[key]) {
          return key;
        }
      }
    );
    feed.cols_to_include = cols_to_include.length
      ? JSON.stringify(cols_to_include)
      : null;

    feed.country = country.value;
    if (NO_PANEL_JOIN_COUNTRIES.includes(feed.country)) {
      feed.do_panel_join = false;
    }
    feed.data_format = feed.data_format.value;

    if (feed.pbse_version) {
      feed.pbse_version = feed.pbse_version.value;
    }

    if (feed.tivo_report) {
      feed.pdp_use_crosswalk = false;
      feed.do_panel_join = false;
    }
    if (feed.type === "tivo content viewership") {
      feed.do_panel_join = false;
      // feed.pbse_version = "1.2.0";
    }

    if ([
      "tivo all viewership",
      "tivo all viewership ad",
      "tivo all viewership content",
    ].includes(feed.type)) {
      feed.do_panel_join = false;
      if (!feed.kantar_filter_expression) {
        feed.kantar_filter_expression = { brand_blacklist: ["Unknown Brand"] };
      }
    }

    if (feed.type === "geo weights") {
      feed.pdp_use_crosswalk = false;
      feed.do_panel_join = false;
      feed.kantar_filter_expression = null;
      feed.pbse_version = null;
      feed.quality_metrics = {};
    }

    if (feed.type === "geo weights" || feed.type === "demographic panel" || feed.type === 'streaming geo panel') {
      feed.misc_json = {
        ...feed.misc_json,
        cadence: feed.cadence
      };
    }

    if (buyOrContentTypeFeedsParam[feed.type]) {
      feed.misc_json = {
        ...feed.misc_json,
        [buyOrContentTypeFeedsParam[feed.type]]:
          feed.selectedBuyOrContentType.value,
      };
    }

    if (
      feed.type === "content viewership" ||
      feed.type === "tivo content viewership" ||
      feed.type === "spot exposure" ||
      feed.type === "tivo spot exposure" ||
      feed.type === "demographic panel" ||
      feed.type === "geo weights" ||
      feed.type === 'all viewership' ||
      feed.type === 'all viewership ad' ||
      feed.type === 'all viewership content' ||
      feed.type === 'tivo all viewership' ||
      feed.type === 'tivo all viewership ad' ||
      feed.type === 'tivo all viewership content' ||
      feed.type === 'streaming geo panel'
    ) {
      feed.misc_json = {
        ...feed.misc_json,
        deployment_filter: "aflow3",
      };

      if (canSetDeliveryMethod) {
        feed.misc_json.delivery = "airflow";
      }
    }

    let commonXrefMisc = {
      ...feed.misc_json,
      deployment_filter: "aflow3",
      mapping_id: "ip",
      lookback_weeks: 26,
    };

    if (canSetDeliveryMethod) {
      commonXrefMisc.delivery = "airflow";
    }

    if (feed.type === "x_ref") {
      feed.misc_json = {
        ...commonXrefMisc,
        prod_weekday:
          feed.x_ref_cadence === "daily"
            ? "daily"
            : feed.x_ref_cadence_day.value,
      };
    }
    if (feed.type === "tivo x_ref" || feed.type === "tivo+acr x_ref") {
      feed.misc_json = {
        ...commonXrefMisc,
        prod_weekday: "tue",
      };
    }

    feed.pdp_infomediary = null;

    delete feed.x_ref_cadence;
    delete feed.x_ref_cadence_day;
    delete feed.deliveryAirflow;
    delete feed.cadence;
    delete feed.cadenceError;
    delete feed.selectedBuyOrContentType;

    // Format dates to YYYY-MM-DD strings to avoid timezone issues
    if (feed.service_start) {
      feed.service_start = moment(feed.service_start).format('YYYY-MM-DD');
    }
    if (feed.service_stop) {
      feed.service_stop = moment(feed.service_stop).format('YYYY-MM-DD');
    }

    return this.props.onSubmit(feed).then((action) => {
      this.setState({ loading: false });
      return action;
    });
  }

  renderStep() {
    const { clients, isSample, clientId } = this.props;
    const { feed, step, includeAllBrands } = this.state;
    const selectedClient = clients.find(
      (client) => client.id === feed.client_id
    );

    if (step === "setCountry") {
      return (
        <CountrySelection
          selectedCountry={feed.country}
          setSelectedCountry={this.setSelectedCountry}
        />
      );
    }

    if (step === "clientAndType") {
      return (
        <ClientAndType
          feed={feed}
          clients={clients}
          onChangeFeed={this.onChangeFeed}
          clientId={clientId}
          reportConfigs={this.props.reportConfigs}
        />
      );
    }

    if (step === "clientCredentials") {
      return <ClientCredentials selectedClient={selectedClient} />;
    }

    if (step === "includedContent" && feed.type !== "geo weights") {
      return (
        <IncludedContent
          feed={feed}
          onChangeFeed={this.onChangeFeed}
          includeAllBrands={includeAllBrands}
          onChangeBrandsSelection={this.onChangeBrandsSelection}
        />
      );
    }

    if (step === "feedSpecifications") {
      const selectedClient = this.props.clients.find(
        (client) => client.id === this.state.feed.client_id
      );

      return (
        <FeedSpecifications
          client={selectedClient}
          feed={feed}
          onChangeFeed={this.onChangeFeed}
        />
      );
    }

    if (step === "datesAndCriteria") {
      return (
        <DatesAndCriteria
          feed={feed}
          onChangeFeed={this.onChangeFeed}
          isSample={isSample}
          selectedCriterias={this.state.selectedCriterias}
          onCriteriaChange={this.onCriteriaChange}
          checkAll={this.state.checkAll}
          onCheckAllChange={this.onCheckAllChange}
          setInitialSelectedValues={this.setInitialSelectedValues}
          updateCriteria={this.updateCriteria}
          reportConfigs={this.props.reportConfigs}
        />
      );
    }

    if (step === "successMessage") {
      return <SuccessMessage successMessage={this.state.successMessage} />;
    }
  }

  render() {
    const { show, shouldCloseOnOverlayClick, clients, isSample, reportConfigs } = this.props;
    const {
      step,
      feed,
      loading,
      includeAllBrands,
      selectedCriterias,
    } = this.state;
    const selectedClient = clients.find(
      (client) => client.id === feed.client_id
    );

    return (
      <Modal
        isOpen={show}
        onRequestClose={this.onDismiss}
        style={modalStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
        <Header
          feed={feed}
          selectedClient={selectedClient}
          step={step}
          onDismiss={this.onDismiss}
        />
        {this.renderStep()}
        <Footer
          step={step}
          onDismiss={this.onDismiss}
          feed={feed}
          onChangeFeed={this.onChangeFeed}
          onChangeStep={this.onChangeStep}
          onChangeSuccessMessage={this.onChangeSuccessMessage}
          loading={loading}
          isSample={isSample}
          onSubmit={this.onSubmit}
          includeAllBrands={includeAllBrands}
          selectedCriterias={selectedCriterias}
        />
      </Modal>
    );
  }
}

CreateFeedModal.defaultProps = {
  shouldCloseOnOverlayClick: true,
};

CreateFeedModal.propTypes = {
  show: PropTypes.bool,
  onDismiss: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
  onSubmit: PropTypes.func,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      bucket_path: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      feed_ids: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  isSample: PropTypes.bool,
  clientId: PropTypes.number,
};

export default connect(
  (store) => ({
    clients: selectAllClients(store),
    reportConfigs: store.entities.reportConfigs.reportConfigs
  }),
  {}
)(CreateFeedModal);
